/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/iframe-has-title */
import { Fragment, useState, useCallback, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  SwipeableDrawer,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import {
  CloseRounded,
  DeleteOutlineRounded,
  MenuBookRounded,
  OpenInNewRounded,
  ReportProblemRounded,
  UploadRounded,
} from '@mui/icons-material';

import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone';
import { DragDropContext, Draggable } from 'react-beautiful-dnd';

import PDFTema from '../../../../assets/PDFTema.svg';

import {
  Content,
  Text,
  Card,
  FileListContainer,
  FileInfo,
  FileItem,
  FileIcon,
  FileName,
  FileActions,
  Container,
  TextButton,
  DialogContentStyles,
} from './styles';

import {
  createThemeRequest,
  deleteThemeRequest,
  updateOrderThemesRequest,
  updateThemeRequest,
} from '../../../../services/requests/temas/utils';
import {
  Arquive,
  createFileRequest,
  Meeting,
  getEbookByMeetingIdRequest,
  removeFileInFolderRequest,
} from '../../../../services';
import { Theme } from '../../../../services/requests/temas/types';
import { User } from '../../../../services/requests/usuarios/types';
import fileApi from '../../../../services/requests/arquivos/fileApi';
import { createLogRequest } from '../../../../services/requests/app-logs/utils';

import { maxUploadSize } from '../../../../utils/mimeTypes';

import useCompanyStore from '../../../../store/companies';
import useAuthStore from '../../../../store/auth';

import { AutocompleteInput } from '../../../../components/AutocompleteInput';
import { ConfirmModal } from '../../../../components/ConfirmModal';
import { Input } from '../../../../components/Input';
import WaterMark from '../../../../components/WaterMark';
import { StrictModeDroppable } from '../../../../components/Droppable/Droppable';
import { LoadingBackdrop } from '../../../../components/LoadingBackdrop';
import { ViewerFile } from '../../../../components/ViewerFile';
import PdfViewer from '../../../../components/ViewerFile/Viewer';
import { verifyUserWhiteList } from '../../../../utils/verifyUserWhiteList';

interface AgendaProps {
  meetingId: string;
  listagemTemas: Theme[];
  setListagemTemas: any;
  listaUsuarios: User[];
  listaUsuariosAutocomplete: string[];
  maxMeetingDuration: number;
  meetingSelect: Meeting;
  filesToVerify: any;
  themesFinish: boolean;
}

interface Pauta {
  duration: number;
  id: string;
}

export interface Doc {
  uri: string;
  fileType: string;
  title: string;
  fileId: string;
}

export function Agenda({
  maxMeetingDuration,
  meetingId,
  listagemTemas,
  setListagemTemas,
  listaUsuarios,
  listaUsuariosAutocomplete,
  meetingSelect,
  filesToVerify,
  themesFinish,
}: AgendaProps) {
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogErrorOpen, setDialogErrorOpen] = useState(false);
  const [idTema, setIdTema] = useState('');
  const [indexSelected, setIndexSelected] = useState(0);
  const [durationTotal, setDurationTotal] = useState<Pauta[]>([
    { duration: 0, id: '' },
  ]);
  const [filesList, setFilesList] = useState<any[]>([]);
  const [docsExistList, setDocsExistList] = useState<any[]>([]);
  const [selectedDoc, setSelectedDoc] = useState<Doc>({} as Doc);
  const [openDocViewer, setOpenDocViewer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [openModalToViewEbook, setOpenModalToViewEbook] = useState(false);
  const [keys, setKeys] = useState<string[]>();
  const [loadingEbook, setLoadingEbook] = useState(true);
  const [pdfToView, setPdfToView] = useState<any>();
  const [urlConvertedToView, setUrlConvertedToView] = useState<any[]>([]);
  const [selectedTheme, setSelectedTheme] = useState<Theme | null>(null);
  const [fileUrl, setFileUrl] = useState('');
  const [totalDuration, setTotalDuration] = useState<number>(0);
  const [isDurationExceeded, setIsDurationExceeded] = useState(false);

  const userOnCompany = selectedCompany?.users?.some(u => u.id === user?.id);
  const userFiltered = meetingSelect?.guests?.find(u => u?.id === user?.id);
  const userOnWhiteList = !!verifyUserWhiteList(user?.email as string);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      title: Yup.string()
        .required('É necessário adicionar um Título.')
        .min(4, 'Mínimo de 4 Dígitos'),
      duration: Yup.string().nullable().notRequired(),
      // .moreThan(0, 'A duração não pode ser menor que 0'),

      description: Yup.string().nullable().max(4000, 'Máximo de 4000 dígitos'),
    });
  }, []);

  const { control, handleSubmit, setValue, reset } = useForm({
    resolver: yupResolver(formValidation()),
    reValidateMode: 'onBlur',
  });

  const handleControlDrawerTheme = () => {
    reset();
    setIdTema('');
    setFilesList([]);
    setDocsExistList([]);
    setDrawerOpen(prevState => !prevState);
  };

  // aqui
  const handleUploadFile = useCallback(
    async (files: any, themeId?: string, folderId?: string) => {
      try {
        setLoadingRequest(true);

        if (files?.length) {
          const fileData = files[0];

          const data = {
            original_name: fileData.name,
            mimetype: fileData.type,
            size: fileData.size,
            key: fileData.name,
            is_downloaded: true,
            is_main: false,
            is_public: true,
            localFile: fileData,
            theme_id: themeId,
            folder_id: folderId,
          };

          const fileResponse = await createFileRequest(
            data as any,
            user?.id as string,
            selectedCompany?.id as string,
            true,
          );

          if (fileResponse?.status === 201) {
            const uploadedFile = {
              ...fileResponse?.data,
              files,
            };

            return { ...uploadedFile };
          }
        }
        return toast.error(
          'Ocorreu um erro ao fazer o Upload do Arquivo, Tente novamente mais tarde',
        );
      } catch (error) {
        console.error('handleUploadFile Error', error);
        return toast.error(
          'Ocorreu um erro ao fazer o Upload do Arquivo, Tente novamente mais tarde',
        );
      } finally {
        setLoadingRequest(false);
      }
    },
    [selectedCompany?.id, user?.id],
  );

  const handleCreateTheme = useCallback(
    async (theme: any) => {
      try {
        setLoading(true);

        let filesWasUploaded = [];

        if (filesList?.length > 0) {
          console.log('filesList', filesList);
          filesWasUploaded = await Promise.all(
            filesList?.map(async f => {
              const file = await handleUploadFile(f.files);

              delete file.files;

              return file;
            }),
          );
        }

        const newTheme = {
          ...theme,
          files: filesWasUploaded,
        };

        const response = await createThemeRequest(
          newTheme,
          selectedCompany?.id as string,
          user?.id as string,
        );

        if (response?.status === 201) {
          let novoTema: Theme = response?.data;
          const themeId = novoTema?.id as string;

          // if (filesList?.length > 0) {
          //   console.log('filesList', filesList);
          //   const filesWasUploaded = await Promise.all(
          //     filesList?.map(async f => {
          //       const file = await handleUploadFile(
          //         f.files,
          //         themeId,
          //         novoTema?.folder_id as string,
          //       );

          //       delete file.files;

          //       return file;
          //     }),
          //   );

          //   const themeWithFile: Partial<Theme> = {
          //     files: [...filesWasUploaded] as any,
          //   };

          //   const responseUpdatedTheme = await updateThemeRequest(
          //     themeWithFile,
          //     themeId,
          //     user?.id as string,
          //     selectedCompany?.id as string,
          //   );

          //   novoTema = {
          //     ...novoTema,
          //     ...themeWithFile,
          //   };

          //   if (responseUpdatedTheme?.status === 200) {
          //     setListagemTemas([...listagemTemas, novoTema]);
          //   }
          // } else {
          setListagemTemas([...listagemTemas, novoTema]);
          // }

          toast.success('Pauta salva com sucesso');
          setIdTema('');
          setDrawerOpen(false);
          reset();
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    },
    [
      filesList,
      handleUploadFile,
      listagemTemas,
      reset,
      selectedCompany?.id,
      setListagemTemas,
      user?.id,
    ],
  );

  const handleUpdateTheme = useCallback(
    async (theme: any, themeId: string) => {
      try {
        setLoading(true);
        let updatedTheme: Theme = theme;

        if (filesList.length > 0) {
          // if (docsExistList.length > 0) {
          //   console.log(docsExistList, 'docsExistList');
          //   console.log(filesList, 'filesList');

          //   await Promise.all(
          //     docsExistList?.map(async d => {
          //       console.log('D', d);
          //       const fileExist = filesList?.filter(fil => fil.id === d.id);

          //       console.log('fileExist', fileExist);
          //       console.log(
          //         'fileExist',
          //         typeof d.id === 'string' && fileExist?.length > 0,
          //       );

          //       if (typeof d.id === 'string' && fileExist?.length > 0) {
          //         console.log('dentro', d?.url);
          //         await handleRemoveFirebaseDocs(d.url);
          //       }
          //     }),
          //   );
          // }

          const filesWasUploaded = await Promise.all(
            filesList?.map(async f => {
              if (typeof f.id === 'number') {
                return handleUploadFile(f.files, themeId, theme.folder_id);
              }
              return { ...f };
            }),
          );

          setFilesList([...filesWasUploaded]);
          setDocsExistList([...filesWasUploaded]);

          const files_ids = filesWasUploaded?.map(f => f.id);

          const themeWithFile: Partial<Theme> = {
            ...updatedTheme,
            files: filesWasUploaded,
            files_ids,
          };

          const responseUpdatedTheme = await updateThemeRequest(
            themeWithFile,
            themeId,
            user?.id as string,
            selectedCompany?.id as string,
          );

          if (responseUpdatedTheme?.status === 200) {
            const responseDataUpdatedTheme = responseUpdatedTheme?.data;

            updatedTheme = {
              ...responseDataUpdatedTheme,
              ...themeWithFile,
            };

            listagemTemas?.splice(indexSelected, 1, updatedTheme);

            setListagemTemas([...listagemTemas]);
          }
        } else {
          const responseUpdatedTheme = await updateThemeRequest(
            {
              ...updatedTheme,
              files: [],
              files_ids: [],
            },
            themeId,
            user?.id as string,
            selectedCompany?.id as string,
          );

          if (responseUpdatedTheme?.status === 200) {
            const responseDataUpdatedTheme = responseUpdatedTheme?.data;

            listagemTemas?.splice(indexSelected, 1, responseDataUpdatedTheme);

            setListagemTemas([...listagemTemas]);
          }
        }

        toast.success('Pauta editada com sucesso');
        setIdTema('');
        setDrawerOpen(false);
        reset();
      } catch (error) {
        console.log('Error handleUpdateTheme', error);
      } finally {
        setLoading(false);
      }
    },
    [
      filesList,
      handleUploadFile,
      indexSelected,
      listagemTemas,
      reset,
      selectedCompany?.id,
      setListagemTemas,
      user?.id,
    ],
  );

  const handleTema = useCallback(
    // eslint-disable-next-line consistent-return
    async (formData: any) => {
      try {
        const findUser = listaUsuarios?.find(us => us.name === formData.caster);
        const durationInput = parseInt(formData?.duration, 10);
        const formDuration = durationInput >= 0 ? durationInput : 0;

        if (meetingId && userFiltered?.profile === 'GS1') {
          const tema = {
            title: formData.title,
            description: formData.description,
            duration: formDuration,
            owner_user_id: findUser?.id || user?.id,
            meeting_id: meetingId as string,
            files: [],
            folder_id: idTema ? selectedTheme?.folder_id : null,
          };

          if (idTema) {
            return handleUpdateTheme(tema, idTema);
          }

          if (listagemTemas?.find(e => e.title === formData.title)) {
            return toast.warning('Já existe uma pauta com esse nome.');
          }

          handleCreateTheme(tema);
        } else {
          toast.warning(
            `Você não tem permissão para ${
              idTema ? 'editar' : 'adicionar'
            } uma pauta`,
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    [
      listaUsuarios,
      meetingId,
      userFiltered?.profile,
      user?.id,
      idTema,
      listagemTemas,
      handleCreateTheme,
      handleUpdateTheme,
      selectedTheme,
    ],
  );

  function handleCloseRemoveDialogTema() {
    setDialogErrorOpen(false);
  }

  async function handleRemoveTema() {
    try {
      setLoading(true);
      setDialogErrorOpen(false);

      const response = await deleteThemeRequest(
        idTema,
        selectedCompany?.id as string,
        user?.id as string,
      );

      if (response?.status === 200) {
        const listaTemaAtualizada = listagemTemas.filter(t => t.id !== idTema);
        const listaPautaAtualizada = durationTotal?.filter(
          d => d.id !== idTema,
        );

        setDurationTotal([...listaPautaAtualizada]);
        setListagemTemas([...listaTemaAtualizada]);
        toast.success('Pauta removida com sucesso');
        setIdTema('');
        setSelectedTheme(null);
        setDrawerOpen(false);
      }
    } catch (error) {
      toast.error('Ocorreu um erro ao remover. Tente novamente mais tarde.');
      console.log({ error });
    } finally {
      setLoading(false);
    }
  }

  const setThemeToEdit = useCallback(
    (t: any, indx: number) => {
      setIdTema(t.id);
      setIndexSelected(indx);
      setDocsExistList(t.files);
      setFilesList(t.files);
      const findUser = listaUsuarios?.find(us => us.id === t.owner_user_id);

      console.log('TEMA', t);
      setSelectedTheme(t);

      setValue('title', t.title);
      setValue('duration', t?.duration);
      setValue('description', t.description);
      setValue('caster', findUser ? findUser?.name : '');
      setDrawerOpen(true);
    },
    [listaUsuarios, setValue],
  );

  const handleFile = useCallback(
    (files: any) => {
      try {
        setLoadingRequest(true);

        if (files?.length === 1) {
          const fileData = files[0];
          // console.log({ fileData });

          const url = URL.createObjectURL(fileData);

          const data = {
            files,
            url,
            id: filesList.length + 1,
            original_name: fileData.name,
            mimetype: fileData.type,
          };

          setFilesList([...filesList, { ...data }]);
          setDocsExistList([...docsExistList, { ...data }]);
          setLoadingRequest(false);
        }
        if (files?.length > 1) {
          let filesListFormatted = [...filesList];
          let docsExistListFormatted = [...docsExistList];

          files?.map((file: any, index: number) => {
            const fileData = file;

            const url = URL.createObjectURL(fileData);

            const data = {
              files: [files[index]],
              url,
              id: filesListFormatted.length + 1,
              original_name: fileData.name,
              mimetype: fileData.type,
            };

            filesListFormatted = [...filesListFormatted, { ...data }];
            docsExistListFormatted = [...docsExistListFormatted, { ...data }];
            setLoadingRequest(false);
          });

          setFilesList([...filesListFormatted]);
          setDocsExistList([...docsExistListFormatted]);
        }
        if (files?.length === 0) {
          toast.warning(
            'Selecione apenas arquivos PDF ao fazer o upload de pautas.',
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    [filesList, docsExistList],
  );

  const handleRemoveFile = useCallback(
    async (fileRemove: any) => {
      if (typeof fileRemove.id === 'string') {
        await removeFileInFolderRequest(
          fileRemove?.key,
          fileRemove.id,
          user?.id as string,
          selectedCompany?.id as string,
        );
      }

      const removeFile = filesList.filter(f => f.id !== fileRemove?.id);

      setFilesList([...removeFile]);
      setDocsExistList([...filesList]);
    },
    [filesList, selectedCompany?.id, user?.id],
  );

  const handleOpenFileViewer = useCallback(
    async (fileId: any) => {
      try {
        setLoadingEbook(true);
        setOpenDocViewer(true);
        // setOpenDocViewer(true);

        // setSelectedDoc({
        //   uri: 'https://firebasestorage.googleapis.com/v0/b/ten-app-c8f8d.appspot.com/o/governanca%2Fdocs%2F8c2cad80-a2f5-485b-89f4-8f013be2c29e?alt=media&token=b0370ab4-d6d6-4a4f-819e-b1e27997a41c',
        //   fileType: 'application/pdf',
        //   title: 'Teste Documento',
        // });

        const foundedFile = filesList.filter(f => f.id === fileId);

        // console.log({ foundedFile, filesList });

        if (foundedFile.length > 0) {
          let uri = '';
          if (typeof foundedFile[0].id === 'string') {
            uri = await fileApi.getFileUrl(
              foundedFile[0].url,
              user?.id as string,
              selectedCompany?.id as string,
            );
          } else {
            uri = foundedFile[0].url;
          }
          const fileType = foundedFile[0].mimetype;
          const fileName = foundedFile[0].original_name;

          setSelectedDoc({
            uri,
            fileType,
            title: fileName,
            fileId,
          });

          await createLogRequest({
            name: user?.name as string,
            user_id: user?.id as string,
            company_id: selectedCompany?.id as string,
            local: 'Reuniões',
            action: 'Visualizou',
            description: `Visualizou o documento ${fileName} na reunião ${meetingSelect?.title}`,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingEbook(false);
      }
    },
    [
      filesList,
      meetingSelect?.title,
      selectedCompany?.id,
      user?.id,
      user?.name,
    ],
  );

  const handleGetFilesByMeeting = useCallback(async () => {
    setLoadingEbook(true);
    try {
      setOpenModalToViewEbook(true);

      if (listagemTemas) {
        const response = await getEbookByMeetingIdRequest(
          meetingId,
          user?.id as string,
          'true',
        );

        if (response?.status === 200) {
          setFileUrl(response?.data);

          if (!userOnWhiteList) {
            await createLogRequest({
              name: user?.name as string,
              user_id: user?.id as string,
              company_id: selectedCompany?.id as string,
              local: 'Reuniões',
              action: 'Visualizou',
              description: `Visualizou o e-book da reunião ${meetingSelect?.title}`,
            });
          }
        }
      }
      if (listagemTemas.length === 0) {
        setLoadingEbook(false);
      }
    } catch (err) {
      console.log('handleGetFilesByMeeting', err);
    } finally {
      setLoadingEbook(false);
    }
  }, [
    listagemTemas,
    meetingId,
    user?.id,
    user?.name,
    userOnWhiteList,
    selectedCompany?.id,
    meetingSelect?.title,
  ]);

  // useEffect(() => {
  //   if (keys) {
  //     const arrUrlsConvertedToView = keys?.map(async (key: string) => {
  //       const responseF = await fileApi.getFileUrl(key);
  //       return responseF;
  //     });
  //     setUrlConvertedToView(arrUrlsConvertedToView);
  //   }
  // }, [keys]);

  // useEffect(() => {
  //   async function responsePromiseToView() {
  //     const response = await Promise.all(
  //       urlConvertedToView.map((url: string) => url),
  //     );
  //     setPdfToView(response);
  //     setLoadingEbook(false);
  //   }
  //   if (urlConvertedToView.length > 0) {
  //     responsePromiseToView();
  //   }
  // }, [urlConvertedToView]);

  useEffect(() => {
    const arrDuration = listagemTemas.map(d => d?.duration as number);
    const duration = arrDuration?.reduce((x, y) => {
      return x + y;
    }, 0);

    setTotalDuration(duration);
  }, [handleTema]);

  useEffect(() => {
    const hasMoreThenOneTheme = listagemTemas.length > 1;
    if (totalDuration > maxMeetingDuration) {
      setIsDurationExceeded(true);
      toast.warning(
        hasMoreThenOneTheme
          ? 'Duração das pautas excedem o tempo de duração da reunião.'
          : 'Duração da pauta excede o tempo de duração da reunião.',
        { toastId: '1' },
      );
    } else {
      setIsDurationExceeded(false);
    }
  }, [totalDuration]);

  const handleCloseModal = () => {
    setOpenModalToViewEbook(false);
    setPdfToView([]);
    setFileUrl('');
    setLoadingEbook(true);
  };

  const onDragEnd = useCallback(
    async (result: any) => {
      const filteredSourceThemes = listagemTemas?.filter(
        p => p.id !== result.draggableId,
      );
      const filteredThemeChange = listagemTemas?.find(
        p => p.id === result.draggableId,
      );

      filteredSourceThemes.splice(
        result.destination.index,
        0,
        filteredThemeChange as Theme,
      );

      if (filteredSourceThemes) {
        setListagemTemas(filteredSourceThemes);

        const themes_ids = filteredSourceThemes.map(theme => theme.id);

        await updateOrderThemesRequest(
          themes_ids as string[],
          user?.id as string,
          selectedCompany?.id as string,
          meetingSelect?.id as string,
        );
      }
    },
    [
      listagemTemas,
      meetingSelect?.id,
      selectedCompany?.id,
      setListagemTemas,
      user?.id,
    ],
  );

  const editDrawerTheme = () => (
    <Box sx={{ width: '560px', height: '100vh' }} role="presentation">
      <Content height="100vh">
        <form onSubmit={handleSubmit(handleTema)} className="formContainer">
          <Box
            display="flex"
            flexDirection="column"
            className="gridContainer"
            padding="0 20px 20px 20px"
          >
            <header className="header-guests">
              <IconButton onClick={handleControlDrawerTheme}>
                <CloseRounded sx={{ color: '#000000' }} />
              </IconButton>

              <h3>{idTema ? 'Editar pauta' : 'Adicionar pauta'}</h3>
            </header>

            <Container>
              <Box
                marginTop="20px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="flex-start"
              >
                <Input
                  label="Nome da Seção"
                  name="title"
                  control={control}
                  fullWidth
                  disabled={!(userFiltered?.profile === 'GS1') || themesFinish}
                />
                <Input
                  label="Duração em minutos"
                  placeholder="30"
                  inputProps={{ min: 0 }}
                  name="duration"
                  control={control}
                  defaultValue={0}
                  type="number"
                  fullWidth
                  disabled={!(userFiltered?.profile === 'GS1') || themesFinish}
                />
                {userFiltered?.profile === 'GS1'
                  ? !themesFinish && (
                      <AutocompleteInput
                        onChange={(t: any) =>
                          setValue('caster', t.target.textContent)
                        }
                        name="caster"
                        control={control}
                        options={listaUsuariosAutocomplete}
                        label="Apresentador"
                      />
                    )
                  : null}
                <Input
                  label="Descrição da pauta"
                  name="description"
                  control={control}
                  fullWidth
                  multiline
                  disabled={!(userFiltered?.profile === 'GS1') || themesFinish}
                  rows={5}
                />
              </Box>
              <Typography className="label">
                Arquivos da pauta
                <span style={{ fontWeight: '400', fontSize: '14px' }}>
                  (Somente PDF)
                </span>
              </Typography>

              {userFiltered?.profile === 'GS1'
                ? !themesFinish && (
                    <Dropzone
                      onDrop={handleFile}
                      accept={{ 'application/pdf': ['.pdf'] }}
                      maxSize={maxUploadSize}
                      multiple
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <Box className="add-logo">
                            <UploadRounded /> Inserir arquivo
                          </Box>
                        </div>
                      )}
                    </Dropzone>
                  )
                : null}
              {/* <Box className="add-logo">
            <SearchRounded /> Procurar em arquivos
          </Box> */}

              {filesList?.length > 0 && (
                <FileListContainer>
                  {filesList?.map((f: Arquive) => (
                    <FileItem key={f?.id}>
                      <FileInfo>
                        <FileIcon>
                          <img src={PDFTema} alt="Icone PDF" />
                        </FileIcon>
                        <FileName>{f?.original_name}</FileName>
                      </FileInfo>
                      <FileActions>
                        {userOnCompany ? (
                          <IconButton
                            onClick={() =>
                              handleOpenFileViewer(f?.id as string)
                            }
                          >
                            <OpenInNewRounded />
                          </IconButton>
                        ) : null}
                        {userFiltered?.profile === 'GS1'
                          ? !themesFinish && (
                              <IconButton onClick={() => handleRemoveFile(f)}>
                                <DeleteOutlineRounded />
                              </IconButton>
                            )
                          : null}
                      </FileActions>
                    </FileItem>
                  ))}
                </FileListContainer>
              )}
              {openDocViewer && (
                <ViewerFile
                  fileUrl={selectedDoc?.uri}
                  loading={loadingEbook}
                  onClose={() => setOpenDocViewer(false)}
                  open={openDocViewer}
                  title={selectedDoc?.title}
                  fileId={String(selectedDoc?.fileId)}
                  isEbook={String(selectedDoc?.fileId)?.length <= 3}
                />
              )}
            </Container>
          </Box>
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            flexDirection="row"
            padding="20px"
            marginTop="auto"
            justifyContent={idTema ? 'space-between' : 'end'}
            className="gridButtons"
          >
            {idTema && userFiltered?.profile === 'GS1'
              ? !themesFinish && (
                  <Button
                    variant="contained"
                    className="btn-delete-guest"
                    onClick={() => setDialogErrorOpen(true)}
                    color="error"
                  >
                    Deletar pauta
                  </Button>
                )
              : null}
            {userFiltered?.profile === 'GS1'
              ? !themesFinish && (
                  <Button
                    variant="contained"
                    className="btn-save-guest"
                    type="submit"
                    color="success"
                    disabled={loading}
                  >
                    SALVAR PAUTA
                  </Button>
                )
              : null}
          </Box>
        </form>
      </Content>
    </Box>
  );

  return (
    <Box width="100%">
      {loading && (
        <LoadingBackdrop
          text={`${idTema ? 'Alterando' : 'Adicionando'} pauta na reunião`}
          component={meetingSelect.title}
          loading={loading}
        />
      )}
      <Fragment key="right">
        <div className="content">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '60px',
              marginBottom: '10px',
            }}
          >
            <Box display="flex" alignItems="center" gap="15px">
              <Text>Pautas da Reunião</Text>
              {isDurationExceeded && (
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Tooltip
                    title={`A duração das pautas (${totalDuration} minutos) é maior que a duração da reunião.`}
                  >
                    <ReportProblemRounded
                      sx={{ width: '35px', height: '35px', color: '#f1c40f' }}
                    />
                  </Tooltip>
                </Box>
              )}
            </Box>
            {meetingSelect?.canceled_at ? (
              ''
            ) : userFiltered?.profile === 'GS1' || userOnWhiteList ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '15px',
                }}
              >
                {filesToVerify?.length > 0 && (
                  <Button
                    variant="outlined"
                    onClick={handleGetFilesByMeeting}
                    sx={{
                      width: '204px',
                      height: '40px',
                      padding: '6px 16px 6px 12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-evenly',
                      gap: '8px',
                    }}
                  >
                    <MenuBookRounded />
                    <TextButton> E-book da reunião </TextButton>
                  </Button>
                )}

                {totalDuration === maxMeetingDuration
                  ? !themesFinish && (
                      // <Tooltip
                      //   title="Duração de pautas excedida."
                      //   arrow
                      //   placement="top"
                      // >
                      <Button
                        onClick={handleControlDrawerTheme}
                        variant="contained"
                        color="primary"
                        className={`btn-rounded  ${
                          meetingId !== '' ? 'btn-edit' : 'disabled'
                        }`}
                        sx={{
                          width: '204px',
                          height: '40px',
                          padding: '6px 16px 6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-evenly',
                        }}
                      >
                        Adicionar Pauta
                      </Button>
                      // </Tooltip>
                    )
                  : !themesFinish && (
                      <Button
                        onClick={handleControlDrawerTheme}
                        variant="contained"
                        color="primary"
                        className={`btn-rounded  ${
                          meetingId !== '' ? 'btn-edit' : 'disabled'
                        }`}
                        sx={{
                          width: '204px',
                          height: '40px',
                          padding: '6px 16px 6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-evenly',
                        }}
                      >
                        Adicionar Pauta
                      </Button>
                    )}
              </Box>
            ) : userOnCompany || userOnWhiteList ? (
              filesToVerify?.length > 0 && (
                <Button
                  variant="outlined"
                  onClick={handleGetFilesByMeeting}
                  sx={{
                    width: '204px',
                    height: '40px',
                    padding: '6px 16px 6px 12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                    gap: '8px',
                  }}
                >
                  <MenuBookRounded />
                  <TextButton> E-book da reunião </TextButton>
                </Button>
              )
            ) : null}
          </Box>
          <DragDropContext onDragEnd={onDragEnd}>
            <StrictModeDroppable droppableId="1">
              {(provided, snapshot) => (
                <Box
                  ref={provided.innerRef}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                  {...provided.droppableProps}
                >
                  {listagemTemas?.length > 0 ? (
                    listagemTemas?.map((t, index) => (
                      <Draggable
                        draggableId={`${t.id}`}
                        index={index}
                        key={t.id}
                      >
                        {_provided => (
                          <Card
                            ref={_provided.innerRef}
                            {..._provided.draggableProps}
                            {..._provided.dragHandleProps}
                            onClick={() => setThemeToEdit(t, index)}
                            key={t.id}
                            sx={{
                              ..._provided.draggableProps.style,
                              boxShadow: snapshot.isDraggingOver
                                ? '0 2px 5px rgba(0, 0, 0, 0.1)'
                                : 'unset',
                              transition: '400ms',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: '20px',
                              }}
                            >
                              <p>#{index + 1}</p>
                              <Box width="30vw">
                                <p className="name">{t?.title}</p>
                                {(t?.duration as number) > 0 && (
                                  <p className="duration">
                                    Duração: {t?.duration as number}{' '}
                                    {(t?.duration as number) > 1
                                      ? 'minutos'
                                      : 'minuto'}
                                  </p>
                                )}
                                {t?.description?.trim() ? (
                                  <p className="description">
                                    Descrição: {t?.description}
                                  </p>
                                ) : null}
                              </Box>
                            </Box>
                            {(t?.files?.length as number) > 0 ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  gap: '10px',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexDirection: 'row',
                                  width: '9rem',
                                  height: '40px',
                                  background: '#EEEEEE',
                                  borderRadius: '6px',
                                  padding: '8px 10px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'Roboto',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    letterSpacing: '0.15px',
                                    color: '#424242',
                                  }}
                                >
                                  Contém {t.files && t.files.length}
                                  {t.files && t?.files?.length > 1
                                    ? ' arquivos'
                                    : ' arquivo'}
                                </Typography>
                              </Box>
                            ) : (
                              ''
                            )}
                            {(t?.files && t.files.length > 0) ||
                            themesFinish ? (
                              ''
                            ) : (
                              <Dropzone
                                onDrop={handleFile}
                                accept={{ 'application/pdf': ['.pdf'] }}
                                maxSize={maxUploadSize}
                                multiple
                              >
                                {({ getRootProps, getInputProps }) => (
                                  <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    {userFiltered?.profile === 'GS1' && (
                                      <Button className="btn-archive">
                                        <UploadRounded /> Arquivo
                                      </Button>
                                    )}
                                  </div>
                                )}
                              </Dropzone>
                            )}
                          </Card>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <div className="box-items">
                      <div className="agenda-left">
                        <Typography>
                          Nenhuma pauta adicionada até o momento...
                        </Typography>
                      </div>
                    </div>
                  )}
                  {provided.placeholder}
                </Box>
              )}
            </StrictModeDroppable>
          </DragDropContext>
        </div>
        <SwipeableDrawer
          className="drawer"
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          onOpen={() => setDrawerOpen(true)}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {editDrawerTheme()}
        </SwipeableDrawer>
      </Fragment>

      <ConfirmModal
        open={dialogErrorOpen}
        onClose={() => setDialogErrorOpen(false)}
        onCancel={() => handleCloseRemoveDialogTema()}
        onConfirm={() => handleRemoveTema()}
        title="Deletar pauta"
        subtitle="Ao confirmar, a pauta será deletada da reunião junto com seus arquivos, caso existam. Deseja prosseguir?"
        btnTextCancel="CANCELAR"
        btnTextConfirm="confirmar"
        type="error"
      />
      <Dialog
        open={openModalToViewEbook}
        fullWidth
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        sx={{
          width: '100%',
          height: '100%',
        }}
        PaperProps={{
          sx: {
            height: '100%',
            width: '100%',
            maxHeight: 'none',
            maxWidth: 'none',
            margin: '0',
            borderRadius: '0px',
            backgroundColor: '#5f5f5f',
            // overflow: 'auto',
            // backgroundColor: '#1a1a1a',
          },
        }}
      >
        <Box width="100%" height="100%">
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '5px 10px',
              backgroundColor: 'rgb(238, 238, 238)',
              position: 'fixed',
              height: '52px',
              width: '100%',
              margin: '0px',
              zIndex: '10',
            }}
          >
            <Typography
              sx={{
                color: '#000000',
                fontFamily: 'Roboto',
                fontWeight: '500',
                fontSize: '19px',
                lineHeight: '29px',
              }}
            >
              {`E-book da reunião ${meetingSelect?.title}`}
            </Typography>
            <IconButton onClick={handleCloseModal}>
              <CloseRounded sx={{ fontSize: '25px', color: '#000000' }} />
            </IconButton>
          </DialogTitle>

          <DialogContentStyles
            sx={{
              height: 'fit-content',
              padding: 0,
              marginTop: '52px',
            }}
            onContextMenu={e => e.preventDefault()}
          >
            {loadingEbook ? (
              <Box
                width="100%"
                height="100%"
                padding="20px"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress />
              </Box>
            ) : fileUrl ? (
              // <WaterMark
              //   fileUrl={fileUrl}
              //   fileId=""
              //   isEbook
              //   fileName={
              //     `E-book da Reunião ${meetingSelect?.title}` ||
              //     'E-book da Reunião'
              //   }
              // />
              <PdfViewer
                fileUrl={fileUrl}
                fileId=""
                isEbook
                fileName={
                  `E-book da Reunião ${meetingSelect?.title}` ||
                  'E-book da Reunião'
                }
              />
            ) : (
              'Nenhum documento adicionado a reunião'
            )}
          </DialogContentStyles>
        </Box>
      </Dialog>
    </Box>
  );
}
